<template>
  <component
    :is="stepperComponent"
    :key="breakpoint"
    :sections="sections"
    :currentIndex="currentIndex"
    :completed="completedIndices"
    @navigate="navigate" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useViewport } from "@/composables/useViewport";
import DesktopStepper from "@/features/progress-stepper/components/DesktopStepper.vue";
import MobileStepper from "@/features/progress-stepper/components/MobileStepper.vue";
import type { Section } from "@/features/progress-stepper/models/Section";

const props = defineProps<{
  sections: Section[];
  currentIndex: number;
  completedIndices: number[];
}>();
const emit = defineEmits<{
  (e: "navigate", idx: number): void;
}>();

const { breakpoint } = useViewport();

// Pick which component to render
const stepperComponent = computed(() => (breakpoint.value === "mobile" ? MobileStepper : DesktopStepper));

function navigate(idx: number) {
  emit("navigate", idx);
}
</script>
